import axios from "axios";
import apiClient from './apiClient';
export const fetchAllTags = async (cancelToken) => {
    try {
        const { data } = await apiClient.get(`/api/tags`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const createTags= (payload) => {
    return axios.post(`/api/tags`, payload);
};
export const editTagsAdd= (payload) => {
    return axios.post(`/api/tags`, payload);
};

export const editTagsRemove = (payload) => {
    return axios.patch(`/api/tags/remove`, payload);
};

export const fetchCurrentTags = (WIID) => {
    return axios.get(`/api/tags/wip/${WIID}`)
}

